import { FC } from "react";
import { Container } from "@epcnetwork/core-ui-kit";

const JobDetailsPage: FC = () => {
  return <Container>test</Container>;
};

export { JobDetailsPage };
